import { create } from "@mui/material/styles/createTransitions";
import Apis from "../../config/Apis";
import Axios from "../../config/Axios";
import { headers } from "../../utills";
import { getCustomer, getDealership } from "../Actions/CompanyAction";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";

export const CompanyMiddleware = {
  getCustomers: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const { data } = await Axios.post(
            Apis.company("customers", params?.url),
            params,
            headers.config()
          );
          if (data?.success) {
            resolve(data?.data);
            dispatch(getCustomer(data?.data));
          } else {
            reject(data?.data);
            dispatch(showAlert({ type: "error", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateCustomer: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userData?.id);
          formdata.append("name", userData?.name);
          formdata.append("email", userData?.email);
          formdata.append("contact_no", userData?.contactNo);
          formdata.append("address", userData?.address);
          formdata.append("first_name", userData?.firstName);
          formdata.append("last_name", userData?.lastName);
          formdata.append("status", userData?.status == 1 ? "active" : "inactive");
          const data = await Axios.post(
            Apis.company("updateCustomer"),
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(CompanyMiddleware.getCustomers({}));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update customer",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  createCustomer: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userData?.id);
          formdata.append("name", userData?.name);
          formdata.append("email", userData?.email);
          formdata.append("contact_no", userData?.contactNo);
          formdata.append("address", userData?.address);
          formdata.append("first_name", userData?.firstName);
          formdata.append("last_name", userData?.lastName);
          const data = await Axios.post(
            Apis.company("createCustomer"),
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(CompanyMiddleware.getCustomers({}));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update customer",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getDealerships: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const { data } = await Axios.post(
            Apis.company("dealerships", params?.url),
            params,
            headers.config()
          );
          if (data?.success) {
            resolve(data?.data);
            dispatch(getDealership(data?.data));
          } else {
            reject(data?.data);
            dispatch(showAlert({ type: "error", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  createDealership: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("name", userData?.name);
          formdata.append("email", userData?.email);
          formdata.append("contact_no", userData?.contactNo);
          formdata.append("address", userData?.address);
          formdata.append("first_name", userData?.firstName);
          formdata.append("last_name", userData?.lastName);
          const data = await Axios.post(
            Apis.company("createDealership"),
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(CompanyMiddleware.getDealerships({}));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create dealership",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateDealership: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userData?.id);
          formdata.append("name", userData?.name);
          formdata.append("email", userData?.email);
          formdata.append("contact_no", userData?.contactNo);
          formdata.append("address", userData?.address);
          formdata.append("first_name", userData?.firstName);
          formdata.append("last_name", userData?.lastName);
          formdata.append("status", userData?.status == 1 ? "active" : "inactive");
          const data = await Axios.post(
            Apis.company("updateDealership"),
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(CompanyMiddleware.getDealerships({}));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update dealership",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
